import { render, staticRenderFns } from "./PrivacyJp.pug?vue&type=template&id=4ca78157&scoped=true&lang=pug&"
import script from "./PrivacyJp.vue?vue&type=script&lang=js&"
export * from "./PrivacyJp.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyJp.scss?vue&type=style&index=0&id=4ca78157&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca78157",
  null
  
)

export default component.exports